import Vue from 'vue'

import './registerServiceWorker'

import VueClipboard from 'vue-clipboard2'
import VueCurrencyInput from 'vue-currency-input'
import VueDebounce from 'vue-debounce'
import VueTheMask from 'vue-the-mask'

import 'material-icons/iconfont/material-icons.css'
import './assets/css/tailwind.css'
import './assets/scss/main.scss'

import './class-component-hooks'
import './validators'
import './vuesax'
import './vue-moment'
import './vue-numerals'

import router from './router'
import store from './store'
import { VueCurrencyOptions } from './vue-currency-input'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueClipboard)

Vue.use(VueCurrencyInput, {
  globalOptions: VueCurrencyOptions
})

Vue.use(VueDebounce, {
  listenTo: 'input'
})

Vue.use(VueTheMask)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
